import { createContext, useContext } from "react";

type FiltroPopoverContextValue = {
  // Id da condição cujo popover de operador/valor está aberto — só um por
  // vez. Cada FiltroCondicaoCard deriva seu `isOpen` comparando com o
  // próprio id, então abrir um fecha automaticamente qualquer outro
  // aberto (sem isso, cada card tinha seu próprio useDisclosure e vários
  // popovers podiam ficar abertos ao mesmo tempo pela árvore de filtro).
  openId: string | null;
  // Troca o alvo sem validar — só pra quem já é dono do popover aberto
  // corrigir a si mesmo (ex.: "Trocar campo", que fecha e deixa o efeito de
  // auto-abrir reabrir depois; "Remover", que descarta a condição inválida
  // de vez). Nunca use isso pra abandonar a condição aberta em favor de
  // outra — pra isso existe `requestOpenId`.
  setOpenId: (id: string | null) => void;
  // Pede pra fechar o popover aberto (id === null) ou abrir outro —
  // recusa (retorna false) se a condição aberta no momento tiver operador
  // ou valor em branco, sinalizando o erro nela (ver `erroId`) em vez de
  // deixar fechar/trocar. Use isso em qualquer ação que abandone a
  // condição aberta: clicar noutra pill, criar uma condição/subgrupo novo,
  // apertar Esc ou o botão de fechar do popover.
  requestOpenId: (id: string | null) => boolean;
  // Id da condição que acabou de recusar um requestOpenId — só ela deve
  // mostrar a mensagem de erro (limpo assim que uma troca é aceita, e
  // some sozinho quando o campo é preenchido, ver condicaoEstaCompleta).
  erroId: string | null;
};

export const FiltroPopoverContext = createContext<FiltroPopoverContextValue>({
  openId: null,
  setOpenId: () => {},
  requestOpenId: () => true,
  erroId: null,
});

export const useFiltroPopover = () => useContext(FiltroPopoverContext);
